import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { addAuth, signIn } from '../../api/authApi';
import { AuthData, AuthResponse, NewAuthData } from '../../types/api/authApi';
import { AuthState } from '../../types/features/authSlice';

export const getAuth = createAsyncThunk<AuthResponse, AuthData>(
  'auth/getAuth',
  async (data) => {
    const response = await signIn(data);
    return response.data; // Assumes response has a 'data' property
  }
);

export const createAuth = createAsyncThunk<AuthResponse, NewAuthData>(
  'auth/createAuth',
  async (newauth: any) => {
    const response = await addAuth(newauth);
    return response.data; // Assumes response has a 'data' property
  }
);

export const removeAuth = createAsyncThunk<Boolean>('auth/removeAuth', async () => {
  return true;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : null,
    status: null,
    msg: ''
  } as AuthState, // Type the initialState with AuthState
  reducers: {
    resetStatus: (state) => {
      state.status = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuth.fulfilled, (state, action: PayloadAction<AuthResponse>) => {
        state.user = action.payload.data;
        state.msg = action.payload.msg;
        state.status = true;
      })
      .addCase(createAuth.fulfilled, (state, action: PayloadAction<AuthResponse>) => {
        state.status = true;
        state.msg = action.payload.msg;
      })
      .addCase(removeAuth.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = false
        state.user = {}
        state.msg = ""
      })
  }
});

export const { resetStatus } = authSlice.actions;

export default authSlice.reducer;
